<template>
    <EonCookies class="cookies" v-if="!isMobile()">
    </EonCookies>
    <Toast position="top-center" group="tc" @close="onClose">
    </Toast>
    <Toast position="top-right" group="login" style="width: auto">
    </Toast>
    <div :class="['map-layout-wrapper', { 'map-layout-wrapper-with-sidebar': sidebarState.visible }]">
        <EonTabMenuMobile :leftItems="mobileMenuLeftItems" :rightItems="isUserLoggedIn ? mobileMenuRightItems : null"
                          :key="`mobile-${isUserLoggedIn}-top`" @toggle-login-sidebar="toggleLoginSidebar"
                          @handle-item-click="handleItemClick" v-if="isMobile()" class="mobile-menu-top"/>
        <EonTabMenuMobileBottom :menuItems="mobileMenuBottomItems"
                                :key="`mobile-${isUserLoggedIn}`" @toggle-login-sidebar="toggleLoginSidebar"
                                @handle-item-click="handleItemClick" :isUserLoggedIn="isUserLoggedIn" :onLogout="logout"
                                v-if="isMobile()"/>
        <EonTabMenu :leftItems="menuLeftItems" :rightItems="isUserLoggedIn ? menuRightItems : null"
                    :key="isUserLoggedIn" @toggle-login-sidebar="toggleLoginSidebar"
                    @handle-item-click="handleItemClick" v-else/>
        <EonSidebarMobile v-if="isMobile()" v-model:visible="sidebarState.login" :modal="false" position="right"
                          class="sidebar" @hide="hideLoginSidebar" @login="loginMobile" @register="register"
                          @remind="remind" />
        <Sidebar v-model:visible="sidebarState.login" position="right"
                 :modal="false" @hide="hideLoginSidebar()" v-else>
            <template #header>
                <div class="logo-container logo">
                    <a href="https://stoen.pl/">
                        <img class="logo" src="../../assets/logoStoenRed.svg"
                             alt="Przejście na stronę główną stoen.pl" />
                    </a>
                </div>
            </template>
            <div class="login-form">
                <VeeForm @submit="login(this.loginForm)">
                    <h2>{{$t('message.login.action.login')}}</h2>
                    <div class="login-inputs">
                        <EonInputText rules="required|email" name="login" v-model="loginForm.login"
                                      :label="$t('message.login.eonLogin')"/>
                        <EonPassword rules="required" name="password"
                                     v-model="loginForm.password"
                                     :label="$t('message.login.password')"/>

                    </div>
                    <div class="login-actions">
                        <EonButton :label="$t('message.login.action.login')"
                                   extension="-20" type="submit" />
                        <EonHref href="/public/remind" :label="$t('message.login.action.eonRemindPassword')"
                                 color="red" title="Zmiana widoku strony" />
                    </div>
                </VeeForm>
            </div>
            <h2>{{ 'Nie masz konta?' }}</h2>
            <EonOutlinedButton :label="$t('message.login.action.register')" type="button"
                               @click="pushToRegisterView" extension="-20" title="Zmiana widoku strony" />
        </Sidebar>
        <button v-if="$route.name === 'publicMapView'" class="sidebar-button"
                @click="toggleInfoSidebar()" type="button">
            <span class="sidebar-button-text">Powiadomienia o przerwach</span>
        </button>
        <Sidebar v-model:visible="sidebarState.info" position="right"
                 :modal="false" @hide="hideInfoSidebar()">
            <template #header>
                <div class="logo-container logo">
                    <a href="https://stoen.pl/">
                        <img class="logo" src="../../assets/logoStoenRed.svg"
                             alt="Przejście na stronę główną stoen.pl" />
                    </a>
                </div>
            </template>
            <div class="sign-up-for-notifications flex flex-column justify-content-center">
                <h2>Chcesz wiedzieć,<br/>kiedy nie będzie prądu?</h2>
                <EonButton :label="$t('message.login.action.signUpHere')" type="button"
                           @click="handleRegisterView" :extension="extension" />
                <h2>aby otrzymywać<br/>powiadomienia o przerwach</h2>
                <a href="/public/instrukcja_sms.pdf" class="instruction-href"
                   target="_blank" title="format PDF, rozmiar 335kb">Zobacz, jak to zrobić</a>
                <div class="sidebar-icons">
                    <img src="@/assets/smartphone.svg" alt="smartphone"/>
                    <img src="@/assets/mail.svg" alt="email"/>
                </div>
                <div style="background-image: url('@/assets/mail.svg')"></div>
            </div>
        </Sidebar>
        <router-view @logout="logout"/>
    </div>
</template>

<script>
    import {Form as VeeForm} from "vee-validate";
    import {FontUtils} from "@/utils/FontUtils";
    import EonTabMenu from "@/components/form/EonTabMenu";
    import EonTabMenuMobile from "@/components/form/EonTabMenuMobile";
    import EonTabMenuMobileBottom from "@/components/form/EonTabMenuMobileBottom";
    import Toast from "primevue/toast";
    import {
        getConfigs,
        publicLogin as loginRequest,
        registerPublicUser as registerRequest,
        remindPassword,
    } from "@/swagger/vue-api-client";
    import {maintenanceEndKey, maintenanceShowKey, maintenanceStartKey} from "@/constants";
    import EonCookies from "@/components/form/EonCookies";
    import {SystemRole} from "@/utils/SystemRole";
    import Sidebar from "primevue/sidebar";
    import EonOutlinedButton from "@/components/form/EonOutlinedButton";
    import EonHref from "@/components/form/EonHref";
    import EonInputText from "@/components/form/EonInputText";
    import EonPassword from "@/components/form/EonPassword";
    import EonButton from "@/components/form/EonButton";
    import {StatusCodes} from "@/utils/StatusCodes";
    import {useRouter} from "vue-router";
    import {isMobile} from "@tenrok/vue3-device-detect";
    import EonSidebarMobile from "@/components/form/EonSidebarMobile";

    const dateFormatter = new Intl.DateTimeFormat(
        "pl",
        {
            day: "numeric",
            month: "long",
            year: "numeric",
            hour: "numeric",
            minute: "numeric",
        },
    );

    export default {
        name: "LayoutMap",
        components: {
            EonSidebarMobile,
            EonButton,
            EonPassword,
            EonInputText,
            EonHref,
            EonOutlinedButton,
            Sidebar,
            EonCookies,
            EonTabMenu,
            EonTabMenuMobile,
            EonTabMenuMobileBottom,
            Toast,
            VeeForm,
        },
        data() {
            return {
                fontSize: FontUtils.getFontSize(),
                mode: "login",
                sidebarState: {
                    login: false,
                    info: false,
                    visible: false,
                },
                // loginState: false,
                loginForm: {
                    login: "",
                    password: "",
                },
                registerForm: {
                    fullName: "",
                    email: "",
                    password: "",
                },
                sending: false,
                passwordRemindForm: {
                    email: "",
                },
                myHeight: "",
                maintenanceToastVisible: false,
                maintenanceData: {
                    start: null,
                    end: null,
                    show: false,
                },
                menuLeftItems: [
                    {
                        label: "Mapa",
                        to: "/public",
                    },
                    {
                        label: "Planowane wyłączenia",
                        to: "/public/planned",
                    },
                    {
                        label: "Lista zdarzeń na mapie",
                        to: "/public/map-events-list",
                    },
                    {
                        label: "O Portalu",
                        to: "/public/about",
                    },
                    {
                        label: "Najczęściej zadawane pytania",
                        to: "/public/faq",
                    },
                    {
                        label: "Polityka prywatności",
                        to: "/public/privacy-policy",
                    },
                ],
                menuRightItems: [
                    {
                        id: "myAccount",
                        icon: "pi pi-user",
                        label: "Moje konto",
                        submenuVisible: false,
                        items: [
                            {
                                label: "Ustawienia",
                                to: "/public/user/settings",
                            },
                            {
                                label: "Moje adresy",
                                to: "/public/user/address",
                            },
                            {
                                label: "Moje zgłoszenia",
                                to: "/public/user/reports",
                            },
                        ],
                    },
                    {
                        id: "logout",
                        label: "Wyloguj",
                        icon: "pi pi-sign-out",
                    },
                ],
                mobileMenuLeftItems: [
                    {
                        id: "mobileMenu",
                        icon: "pi pi-bars",
                        items: [
                            {
                                label: "O Portalu",
                                to: "/public/about",
                            },
                            {
                                label: "Najczęściej zadawane pytania",
                                to: "/public/faq",
                            },
                            {
                                label: "Polityka prywatności",
                                to: "/public/privacy-policy",
                            },
                        ],
                    },
                ],
                mobileMenuRightItems: [
                    {
                        id: "myAccount",
                        icon: "pi pi-user",
                        submenuVisible: false,
                        items: [
                            {
                                label: "Ustawienia",
                                to: "/public/user/settings",
                            },
                            {
                                label: "Moje adresy",
                                to: "/public/user/address",
                            },
                            {
                                label: "Moje zgłoszenia",
                                to: "/public/user/reports",
                            },
                        ],
                    },
                    {
                        id: "logout",
                        icon: "pi pi-sign-out",
                    },
                ],
                mobileMenuBottomItems: [
                    {
                        label: "Mapa",
                        to: "/public",
                    },
                    {
                        label: "Planowane wyłączenia",
                        to: "/public/planned",
                    },
                ],
                mobileMenuUserItems: [
                    {
                        label: "Ustawienia",
                        to: "/public/user/settings",
                    },
                    {
                        label: "Moje adresy",
                        to: "/public/user/address",
                    },
                    {
                        label: "Moje zgłoszenia",
                        to: "/public/user/reports",
                    },
                    {
                        id: "logout",
                        label: "Wyloguj",
                    },
                ],
                cookiesPolicyUrl: process.env.VUE_APP_COOKIES_URL,
                isUserLoggedIn: SystemRole.isPublic(),
                router: useRouter(),
            };
        },
        mounted() {
            getConfigs().then((response) => {
                response.data.forEach((config) => {
                    if (config.key === maintenanceStartKey) {
                        this.maintenanceData.start = new Date(config.value);
                    } else if (config.key === maintenanceEndKey) {
                        this.maintenanceData.end = new Date(config.value);
                    } else if (config.key === maintenanceShowKey) {
                        this.maintenanceData.show = config.value === "true";
                    }
                });
                if (this.maintenanceData.show === true) {
                    this.showMaintenanceInfo();
                }
            });
            if (!isMobile) {
                this.sidebarState.info = sessionStorage.getItem("sidebarShown") !== "true";
                sessionStorage.setItem("sidebarShown", "true");
            }
            document.addEventListener("click", this.handleClickOutside);
            this.unsubscribe = FontUtils.onChange((size) => {
                this.fontSize = size;
            });
        },
        beforeUnmount() {
            if (this.unsubscribe) this.unsubscribe();
        },
        methods: {
            handleClickOutside(event) {
                const menu = document.querySelector(".my-account-menu");
                const icon = document.querySelector(".menu-icon");

                const clickedInMenu = menu && menu.contains(event.target);
                const clickedInIcon = icon && icon.contains(event.target);

                if (clickedInIcon) {
                    return;
                }

                if (!clickedInMenu) {
                    const accountItem = this.menuRightItems.find((i) => i.id === "myAccount");
                    if (accountItem) accountItem.submenuVisible = false;

                    const accountItemMobile = this.mobileMenuRightItems.find((i) => i.id === "myAccount");
                    if (accountItemMobile) accountItemMobile.submenuVisible = false;
                }
            },
            isMobile() {
                return isMobile;
            },
            successToast(message) {
                this.$toast.removeAllGroups();
                this.$toast.add({
                    severity: "success",
                    summary: message,
                    life: 3000,
                    closable: true,
                    group: "login",
                });
            },
            errorToast() {
                this.$toast.removeAllGroups();
                this.$toast.add({
                    severity: "warn",
                    summary: "Niepoprawne dane logowania",
                    life: 5000,
                    closable: true,
                    group: "login",
                });
            },
            registerFailToast() {
                this.$toast.removeAllGroups();
                this.$toast.add({
                    // eslint-disable-next-line max-len
                    severity: "warn", summary: "Nie udało się utworzyć konta. Sprawdź, czy nie posiadasz już konta w Portalu.", life: 5000, closable: false,
                });
            },
            registerSuccessToast() {
                this.$toast.removeAllGroups();
                this.$toast.add({
                    severity: "success",
                    summary: "Konto zostało utworzone. Aby się zalogować potwierdź swój adres email.",
                    life: 5000,
                    closable: false,
                });
            },
            login(loginForm) {
                loginRequest({body: loginForm})
                    .then((response) => {
                        localStorage.setItem("token", response.data.token);
                        localStorage.setItem("userId", response.data.userId);
                        localStorage.setItem("role", response.data.role);
                        localStorage.setItem("fullName", response.data.fullName);
                        localStorage.setItem("area", response.data.area);
                        localStorage.setItem("email", response.data.email);
                        localStorage.setItem("phone", response.data.phone);
                        localStorage.setItem("phoneConfirmer", JSON.stringify(response.data.phoneConfirmer));

                        this.sidebarState.visible = false;
                        this.sidebarState.login = false;
                        this.isUserLoggedIn = true;
                        this.loginForm = {
                            login: "",
                            password: "",
                        };
                        this.successToast("Zalogowano pomyślnie");
                        this.$router.push({name: "publicUserAddress"});
                    })
                    .catch((error) => {
                        switch (error.response.status) {
                            case StatusCodes.UNAUTHORIZED:
                                this.badCredentials = true;
                                this.errorToast();
                                break;
                            case StatusCodes.SERVICE_UNAVAILABLE:
                                this.isBlocked = true;
                                this.badCredentials = false;
                                break;
                            case StatusCodes.FORBIDDEN:
                                this.badCredentials = true;
                                this.errorToast();
                                break;
                            default:
                        }
                    });
            },
            loginMobile(formData) {
                this.login(formData);
            },
            register() {
                registerRequest({body: this.registerForm})
                    .then(() => {
                        this.registerSuccessToast();
                    })
                    .catch((error) => {
                        this.registerFailToast();
                        switch (error.response.status) {
                            case StatusCodes.SERVICE_UNAVAILABLE:
                                this.isBlocked = true;
                                this.badCredentials = false;
                                break;
                            default:
                        }
                    });
                this.registerForm = this.clearRegisterForm();
            },
            clearRegisterForm() {
                return {
                    fullName: "",
                    email: "",
                    password: "",
                };
            },
            pushToRegisterView() {
                this.$router.push({name: "register"});
            },
            handleRegisterView() {
                if (this.isMobile()) {
                    this.toggleLoginSidebar();
                } else {
                    this.pushToRegisterView();
                }
            },
            handleItemClick(item) {
                if (item.id === "logout") {
                    this.logout();
                }
                if (item.id === "myAccount") {
                    item.submenuVisible = !item.submenuVisible;
                }
            },
            toggleLoginSidebar() {
                this.sidebarState.login = !this.sidebarState.login;
                this.sidebarState.info = false;
                setTimeout(() => { this.sidebarState.visible = this.sidebarState.login; }, 200);
            },
            toggleInfoSidebar() {
                this.sidebarState.info = !this.sidebarState.info;
                setTimeout(() => { this.sidebarState.visible = this.sidebarState.info; }, 200);
            },
            hideLoginSidebar() {
                this.sidebarState.login = false;
                this.sidebarState.visible = false;
            },
            hideInfoSidebar() {
                this.sidebarState.info = false;
                this.sidebarState.visible = false;
            },
            showMaintenanceInfo() {
                if (!this.maintenanceToastVisible) {
                    const dateStart = dateFormatter.format(this.maintenanceData.start);
                    const dateEnd = dateFormatter.format(this.maintenanceData.end);

                    this.$toast.add(
                        {
                            // eslint-disable-next-line max-len
                            severity: "warn", summary: "Od " + dateStart + " do " + dateEnd + " planujemy prace serwisowe na Portalu planowanych wyłączeń i awarii. Serwis może być w tym czasie niedostępny. Przepraszamy za utrudnienia.", group: "tc",
                        },
                    );
                    this.maintenanceToastVisible = true;
                }
            },
            onClose() {
                this.maintenanceToastVisible = false;
            },
            logout(message) {
                localStorage.removeItem("token");
                localStorage.removeItem("userId");
                localStorage.removeItem("role");
                localStorage.removeItem("fullName");
                localStorage.removeItem("area");
                localStorage.removeItem("email");
                localStorage.removeItem("phone");

                this.isUserLoggedIn = false;
                if (this.router.currentRoute.meta.requiresAuth === true) {
                    this.$router.push({name: "publicMapView"});
                }

                this.successToast(message || "Zostałeś wylogowany z systemu");
            },
            isDisabled(errors) {
                return !(errors && Object.keys(errors).length === 0
                    && Object.getPrototypeOf(errors) === Object.prototype);
            },
            remind() {
                this.sending = true;
                remindPassword({body: this.passwordRemindForm});
            },
            isPublic() {
                return window.location.href.includes("public");
            },
        },
        watch: {
            "$route.path": function (newPath) {
                if (newPath === "/public/remind") {
                    this.mode = "remind";
                } else if (newPath === "/public/register") {
                    this.mode = "register";
                } else {
                    this.mode = "login";
                }
            },
        },
        computed: {
            extension() {
                return this.fontSize === "2" ? "100" : "-20";
            },
        },
    };
</script>

<style lang="less">
@import "../../components/assets/less/toast.less";
@import "../assets/less/view-with-tab-menu.less";
.mobile-menu-top {
    position: fixed;
    top: 0;
    border-top: none !important;
    border-bottom: 4px solid #E8E8E8 !important;
}
.p-sidebar-right {
    width: 25%;
    .p-sidebar-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        .p-sidebar-close {
            order: -1;
        }
    }
    .p-sidebar-content {
        margin: 0 1em;
        .eon-button {
            align-self: center;
        }
    }
}
.map-layout-wrapper {
    height: 100%;
    display: flex;
    flex-direction: column;
}
.map-layout-wrapper-with-sidebar {
    width: 75%;
    height: 100%;
    display: flex;
    flex-direction: column;
}
.maintenance-banner {
    width: 100%;
    height: 150%;
}

@media screen and (max-width: 1406px) {
    .map-layout-wrapper-with-sidebar {
        width: 70%;
        height: 100%;
        display: flex;
        flex-direction: column;
    }
    .p-sidebar-right {
        width: 30%;
    }
}

@media screen and (max-width: 1173px) {
    .map-layout-wrapper-with-sidebar {
        width: 60%;
        height: 100%;
        display: flex;
        flex-direction: column;
    }
    .p-sidebar-right {
        width: 40%;
    }
}

@media screen and (max-width: 900px) {
    .p-sidebar-right {
        width: 100%;
    }
}
html[data-font-size='2'] {
    .p-sidebar-right {
        width: 50%;
    }
    .map-layout-wrapper-with-sidebar {
        width: 100%;
    }
}
</style>
<style lang="less" scoped>
.login-form {
    margin-bottom: 5em;
    .login-inputs {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        row-gap: 1em;
        margin-bottom: 2em;
    }
    .login-actions {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
    }
}
.register-form {
    margin-bottom: 2em;
    .register-inputs {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        row-gap: 1em;
        margin-bottom: 2em;
    }
    .register-actions {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
    }
}
.policy {
    font-size: 0.75rem;
    margin-bottom: 2em;
}
.logo {
    height: 4em;
    padding-right: 1em;
    padding-left: 1em;
    padding-top: 0.5em;
}
.logo-container {
    display: flex;
    align-items: center;
    padding: 0;
    margin-left: 1em;
}
.sidebar-button {
    position: fixed;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    height: 25%;
    width: 45px;
    background: #EA1B0A;
    color: white;
    border: none;
    border-top-left-radius: 10px;
    border-bottom-left-radius: 10px;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
    z-index: 1000;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    .sidebar-button-text {
        transform: rotate(90deg);
        font-weight: bold;
        white-space: nowrap;
        @media screen and (max-height: 775px) {
            white-space: wrap;
        }
    }

    &:hover {
        background: #B00402;
    }
}
.sign-up-for-notifications {
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center;
    margin-top: 3rem;
}
.sidebar-icons {
    padding-top: 50px;
}
.instruction-href {
    font-weight: bold;
    display: block;
    vertical-align: text-bottom;
    text-align: center;
    color: #EA1B0A;
    display: flex;
    align-self: center;
}
</style>
